import type { SearchDropdownItem } from '@/components/ui/search-dropdown'
import type { RentManagerServiceManagerStatus } from '@super/shared-types'

export const mapStatusToItem = (
  status: RentManagerServiceManagerStatus,
): SearchDropdownItem<number> | null => {
  if (!status.Name) return null
  return {
    id: String(status.ServiceManagerStatusID),
    label: status.Name,
    data: status.ServiceManagerStatusID,
  }
}
